import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

export default function SelectLabels() {
  const [taxCategory, setTaxCategory] = React.useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setTaxCategory(event.target.value);
  };

  return (
    <div>
      <FormControl
        sx={{
          m: 1,
          minWidth: 130,
          "&:focus-within": {
            borderColor: "#E8EAED",
            borderWidth: "1px",
            borderStyle: "solid",
          },
          "&:hover": { borderColor: "#E8EAED" },
        }}
      >
        <Select
          value={taxCategory}
          onChange={handleChange}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={{
            height: 30,
          }}
          MenuProps={{
            PaperProps: {
              style: {
                minWidth: "1%",
                maxWidth: "none",
              },
            },
          }}
        >
          <MenuItem value="" disabled>
            Select
          </MenuItem>
          <MenuItem value={"Adult Disposable Diapers"}>
            Adult Disposable Diapers
          </MenuItem>
          <MenuItem value={"Alcoholic Beverages - Spirit"}>
            Alcoholic Beverages - Spirit
          </MenuItem>
          <MenuItem value={"Alcoholic Beverages"}>Alcoholic Beverages</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}
